import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Mail, Phone, Instagram } from 'lucide-react';

const Contact = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const contactInfo = [
    {
      icon: Phone,
      title: 'WhatsApp',
      value: '+55 44 99944-8428',
      link: 'https://wa.me/5544999448428'
    },
    {
      icon: Mail,
      title: 'Email',
      value: 'arttimeamazon@gmail.com',
      link: 'mailto:arttimeamazon@gmail.com'
    },
    {
      icon: Instagram,
      title: 'Instagram',
      value: '@arttimewatches',
      link: 'https://www.instagram.com/arttimewatches/'
    }
  ];

  return (
    <section
      id="contato"
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 bg-[#121212]"
      data-testid="contact-section"
    >
      <div className="max-w-5xl mx-auto">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
        >
          <div className="uppercase text-[#C9A646] font-sans text-xs md:text-sm tracking-[0.3em] mb-6">
            Entre em Contato
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-white tracking-tight mb-6">
            Vamos Conversar
          </h2>
          <p className="font-sans text-base md:text-lg text-[#A3A3A3] max-w-2xl mx-auto">
            Estamos disponíveis para atendê-lo com a atenção e exclusividade que você merece.
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {contactInfo.map((info, index) => {
            const Icon = info.icon;
            return (
              <a
                key={index}
                href={info.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-center group"
                data-testid={`contact-info-${index}`}
              >
                <div className="inline-flex w-16 h-16 border-2 border-[#C9A646] items-center justify-center mb-6 group-hover:bg-[#C9A646] transition-colors duration-300">
                  <Icon size={28} className="text-[#C9A646] group-hover:text-black transition-colors" />
                </div>
                <div className="font-sans text-sm text-[#C9A646] mb-2 uppercase tracking-wider">{info.title}</div>
                <div className="font-sans text-lg text-white group-hover:text-[#C9A646] transition-colors">
                  {info.value}
                </div>
              </a>
            );
          })}
        </motion.div>

        <motion.div
          className="text-center mt-16 pt-12 border-t border-white/10"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <p className="font-sans text-sm text-[#A3A3A3] leading-relaxed max-w-3xl mx-auto">
            Entre em contato e descubra como podemos ajudá-lo a encontrar a peça perfeita ou avaliar seu relógio com total transparência e profissionalismo.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
